module.exports = __webpack_public_path__ + "static/assets/4b4f79643e193d6c59a12a60833a9543.svg";